const resource = 'commission_groups'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}/`, { params })
  },

  downloadPdf(id) {
    return $axios({
      method: 'GET',
      url: `/${resource}/${id}/report`,
      responseType: 'blob',
    })
  },

  getServiceName: name => 'commissionGroupService',
})
